import { useEffect, useState } from "react";
import { api } from "../../api";
import { useConsoleTown } from "./ConsoleLayout";

export default function ConsoleOverview() {
  const { town, reloadTowns } = useConsoleTown();
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => {
    setError("");
    api.consoleOverview(town.id).then(setData).catch((reason) => setError(reason.message || "概览加载失败"));
  };
  useEffect(load, [town.id]);

  const toggleSleep = async () => {
    setBusy(true);
    try {
      if (town.status === "sleeping") await api.consoleWake(town.id);
      else await api.consoleSleep(town.id);
      await reloadTowns();
      load();
    } catch (reason: any) {
      setError(reason.message || "状态切换失败");
    } finally {
      setBusy(false);
    }
  };

  if (!data && !error) return <div className="py-20 text-center text-sm text-[#77705f]">加载中...</div>;
  if (error) return <div className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">{error}</div>;
  const current = data.town;
  const usage = data.usage7d || {};
  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center gap-3">
        <div>
          <h1 className="text-2xl font-black">{current.name}</h1>
          <p className="mt-1 text-sm text-[#77705f]">第 {current.day} 天 · {String(Math.floor(current.gameMin / 60)).padStart(2, "0")}:{String(current.gameMin % 60).padStart(2, "0")} · {current.weather}</p>
        </div>
        <div className="flex-1" />
        <button disabled={busy} onClick={toggleSleep} className="rounded-lg border border-[#cfc8b5] bg-white px-4 py-2 text-sm font-bold disabled:opacity-50">
          {town.status === "sleeping" ? "唤醒小镇" : "休眠小镇"}
        </button>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {[
          ["居民 / 在线", `${current.residentCount} / ${current.online}`],
          ["成员 / 封禁", `${current.memberCount} / ${current.bannedCount}`],
          ["近 7 日调用", Number(usage.calls || 0).toLocaleString()],
          ["近 7 日 tokens", Number(usage.totalTokens || 0).toLocaleString()],
        ].map(([label, value]) => (
          <div key={label} className="rounded-xl border border-[#ddd7c4] bg-white p-5 shadow-sm">
            <div className="text-xs font-bold text-[#77705f]">{label}</div>
            <div className="mt-2 text-2xl font-black">{value}</div>
          </div>
        ))}
      </div>

      <div className="grid gap-5 xl:grid-cols-[minmax(0,1fr)_320px]">
        <section className="rounded-xl border border-[#ddd7c4] bg-white shadow-sm">
          <div className="border-b border-[#ebe6d6] px-5 py-3.5 font-bold">最新信息流</div>
          <div className="divide-y divide-[#f0ecdf]">
            {(data.latestPosts || []).map((post: any) => (
              <div key={post.id} className="px-5 py-3">
                <div className="text-xs text-[#77705f]">{post.agentName} · 第 {post.day} 天 {Math.floor(post.gameMin / 60)}:{String(post.gameMin % 60).padStart(2, "0")}</div>
                <div className="mt-1 text-sm leading-6 text-[#3f3a32]">{post.content}</div>
              </div>
            ))}
            {!data.latestPosts?.length && <div className="px-5 py-10 text-center text-sm text-[#77705f]">暂无动态</div>}
          </div>
        </section>
        <section className="rounded-xl border border-[#ddd7c4] bg-white p-5 shadow-sm">
          <h2 className="font-bold">待办提醒</h2>
          <div className="mt-4 space-y-3 text-sm">
            <div className="rounded-lg bg-[#f4f8f6] p-3 text-[#245849]">钱包余额：{Number(current.tokenBalance || 0).toLocaleString()} tokens</div>
            <div className="rounded-lg bg-[#f7f4eb] p-3 text-[#665f4f]">当前流速：{current.timeScale}x</div>
            <div className="rounded-lg bg-[#f7f4eb] p-3 text-[#665f4f]">税率：{Math.round(Number(current.taxRate || 0) * 100)}%</div>
          </div>
        </section>
      </div>
    </div>
  );
}
